module.exports = __webpack_public_path__ + "img/hat05_uv_belt_left.7d7494c1.svg";